import _ from 'lodash'
import { html as beautify } from 'js-beautify'
import { findDOMNode } from 'react-dom'
import CodeEditor from './CodeEditor'
import classNames from 'classnames'
import React, { Component } from 'react'

if (process.env.BROWSER) require('../../styles/Preview.less')

class Preview extends Component {

  static defaultProps = {
    height: '100%',
    width: '100%'
  }

  state = {
    backgroundColor: 'white',
    size: 'desktop',
    synchronizeScroll: true,
    viewType: 'iframe'
  }

  size = {
    mobile: '320px',
    desktop: '800px'
  }

  shouldComponentUpdate (nextProps, nextState) {
    return this.props.html !== nextProps.html ||
    this.props.uiSize !== nextProps.uiSize ||
    this.props.height !== nextProps.height ||
    this.props.width !== nextProps.width ||
    this.state.viewType !== nextState.viewType ||
    this.state.size !== nextState.size ||
    this.state.synchronizeScroll !== nextState.synchronizeScroll
  }

  componentWillReceiveProps (nextProps) {
    const { synchronizeScroll, viewType } = this.state

    if (synchronizeScroll) {
      if (this.iframe && viewType === 'iframe') {
        const { scrollHeight } = this.iframe.contentWindow.document.body

        this.iframe.contentWindow.scrollTo(null, (scrollHeight - this.iframe.clientHeight) * (nextProps.scrollTop / 100))
      }

      if (this.editorPreview && viewType === 'html') {
        const height = this.editorPreview.getScrollInfo()

        this.editorPreview.scrollTo(null, nextProps.scrollTop * height.height / 100)
      }
    }
  }

  componentDidMount () {
    const { viewType } = this.state

    this.debouncedResizeIframe = _.debounce(this.resizeIframe, 100)

    if (viewType === 'iframe') {
      this.renderIframe(true)
      this.resizeIframe()
      this.eventIframe()
    }
  }

  componentDidUpdate (prevState) {
    const { viewType } = this.state

    if (prevState.viewType === 'html') {
      window.removeEventListener('resize', this.debouncedResizeIframe)
    }

    if (viewType === 'iframe') {
      this.renderIframe()
      this.resizeIframe()
      this.eventIframe()
    }
  }

  componentWillUnmount () {
    this.editorPreview = this.iframe = null

    window.removeEventListener('resize', this.debouncedResizeIframe)
  }

  eventIframe () {
    window.addEventListener('resize', this.debouncedResizeIframe)
  }

  resizeIframe = () => {
    const { height, width } = this.props
    const { size } = this.state

    if (this.iframe) {
      const iframeWidth = parseInt(this.size[size])
      const heightWithoutUnit = parseInt(height)
      const containerRect = findDOMNode(this).getBoundingClientRect()

      if (iframeWidth > containerRect.width) {
        const ratio = containerRect.width / iframeWidth

        this.iframe.style.height = `${heightWithoutUnit / ratio}px`
        this.iframe.style.transform = `scale(${ratio})`
      } else {
        this.iframe.style.height = height
        this.iframe.style.transform = 'scale(1)'
      }
    }
  }

  renderIframe (firstRender = false) {
    if (this.oldHtml !== this.props.html) {
      this.iframe.srcdoc = this.props.html

      this.oldHtml = this.props.html
    }
  }

  handleIframeLoad = () => {
    if (this.iframe?.contentDocument?.body?.firstElementChild) {
      this.setState({ backgroundColor: this.iframe.contentDocument.body.firstElementChild.style.backgroundColor })
    }
  }

  handleSwitchSize (size) {
    const { viewType } = this.state

    this.setState({ viewType: 'iframe', size })
  }

  handleSwitchHtml = () => {
    this.setState({ viewType: 'html' })

    this.oldHtml = null

    window.removeEventListener('resize', this.debouncedResizeIframe)
  }

  handleSynchronize = () => {
    this.setState({ synchronizeScroll: !this.state.synchronizeScroll })
  }

  handleMinify = () => {
    this.props.toggleMinify()
    this.handleSwitchHtml()
  }

  render () {
    const { html, uiSize, height, toggleMinify, minify } = this.props
    const { viewType, size, backgroundColor, synchronizeScroll } = this.state

    return (
      <div
        className="Preview"
        style={{ backgroundColor }}>
        <div className="Preview-Header">
          <div className="Preview-Toolbar">
            { uiSize !== 'right' &&
              <div className="Preview-Scroll">
                <span onClick={this.handleSynchronize}>
                  <i className={classNames('ion', { 'ion-ios-circle-outline': !synchronizeScroll, 'ion-ios-checkmark': synchronizeScroll })} /> Synchronize scroll
                </span>
              </div> }
            { uiSize !== 'right' &&
            <div className="Preview-Minify">
              <span onClick={this.handleMinify}>
                <i className={classNames('ion', { 'ion-ios-circle-outline': !minify, 'ion-ios-checkmark': minify })} /> Minify HTML
              </span>
            </div> }
            <div className="Preview-SwitchSize">
              <div
                className={classNames({ selected: viewType === 'html' })}
                onClick={this.handleSwitchHtml}>
                View HTML
              </div>
              <div
                className={classNames({ selected: viewType === 'iframe' && size === 'mobile' })}
                onClick={this.handleSwitchSize.bind(this, 'mobile')}>
                <i className="ion ion-iphone" />
              </div>
              <div
                className={classNames({ selected: viewType === 'iframe' && size === 'desktop' })}
                onClick={this.handleSwitchSize.bind(this, 'desktop')}>
                <i className="ion ion-android-desktop" />
              </div>
            </div>
          </div>
        </div>
        { viewType === 'iframe' &&
          <iframe
            ref={r => this.iframe = r}
            onLoad={this.handleIframeLoad}
            style={{
              height,
              width: this.size[size]
            }}
          /> }
        { viewType === 'html' &&
        <CodeEditor
          mode="html"
          name="htmlPreview"
          readOnly={true}
          ref={r => this.editorPreview = r && r._codeMirror }
          value={html} /> }
      </div>
    )
  }

}

export default Preview
